import axios from "axios";
import { BASE_URL, setAuthToken, getUserProfile } from "./api";
import { clearEmployerCompanyCache } from "../hooks/useEmployerCompany";

const TOKEN_KEY = "kiosk_access_token";
const REFRESH_KEY = "kiosk_refresh_token";
const USER_ID_KEY = "kiosk_user_id";

const LEGACY_KEYS = ["access_token", "refresh_token", "user_id"];

function decodeJwtPayload(token) {
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    return JSON.parse(atob(base64));
  } catch {
    return null;
  }
}

export function isEmployerRole(token) {
  const payload = decodeJwtPayload(token);
  const role = String(payload?.user_type || "").trim().toLowerCase();
  return role === "employer";
}

export function clearLegacyTokens() {
  LEGACY_KEYS.forEach((key) => localStorage.removeItem(key));
}

export const getAccessToken = () => localStorage.getItem(TOKEN_KEY);

export const isAuthenticated = () => Boolean(getAccessToken());

export async function validateEmployerSession() {
  const token = getAccessToken();
  if (!token) {
    return false;
  }

  if (!isEmployerRole(token)) {
    logout();
    return false;
  }

  try {
    await getUserProfile();
    return true;
  } catch {
    logout();
    return false;
  }
}

export const login = async ({ identifier, password }) => {
  clearLegacyTokens();

  const response = await axios.post(`${BASE_URL}login/`, {
    identifier,
    password,
  });

  const { access, refresh, user_id: userId } = response.data;

  if (!access) {
    throw new Error("Access token missing in login response");
  }

  if (!isEmployerRole(access)) {
    throw new Error("Only employer accounts can activate the attendance kiosk.");
  }

  localStorage.setItem(TOKEN_KEY, access);
  if (refresh) {
    localStorage.setItem(REFRESH_KEY, refresh);
  }
  if (userId) {
    localStorage.setItem(USER_ID_KEY, String(userId));
  }

  setAuthToken(access);
  return response.data;
};

export const logout = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(REFRESH_KEY);
  localStorage.removeItem(USER_ID_KEY);
  clearEmployerCompanyCache();
  setAuthToken(null);
};
